import { env } from '../../config/env';
import { tokenStorage } from '../../api/tokenStorage';
import type {
  AuthResponse,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  LoginRequest,
  MessageResponse,
  RegisterRequest,
  RegisterResponse,
  ResendEmailVerificationRequest,
  ResetPasswordRequest,
  UpdateProfileRequest,
} from '../../types/api';
import type { User } from '../../types';
import * as http from './authService.http';
import * as mock from './authService.mock';

export interface AuthService {
  login(data: LoginRequest): Promise<AuthResponse>;
  register(data: RegisterRequest): Promise<RegisterResponse>;
  verifyEmail(token: string): Promise<MessageResponse>;
  resendVerificationEmail(data: ResendEmailVerificationRequest): Promise<MessageResponse>;
  forgotPassword(data: ForgotPasswordRequest): Promise<MessageResponse>;
  resetPassword(data: ResetPasswordRequest): Promise<MessageResponse>;
  logout(): Promise<void>;
  getCurrentUser(): Promise<User | null>;
  updateProfile(data: UpdateProfileRequest): Promise<User>;
  changePassword(data: ChangePasswordRequest): Promise<MessageResponse>;
}

const mockAuthService: AuthService = {
  login: mock.mockLogin,
  register: mock.mockRegister,
  verifyEmail: mock.mockVerifyEmail,
  resendVerificationEmail: mock.mockResendVerificationEmail,
  forgotPassword: mock.mockForgotPassword,
  resetPassword: mock.mockResetPassword,
  logout: mock.mockLogout,
  getCurrentUser: () => mock.mockGetCurrentUser(tokenStorage.get()),
  updateProfile: (data) => mock.mockUpdateProfile(tokenStorage.get(), data),
  changePassword: (data) => mock.mockChangePassword(tokenStorage.get(), data),
};

const httpAuthService: AuthService = {
  login: http.httpLogin,
  register: http.httpRegister,
  verifyEmail: http.httpVerifyEmail,
  resendVerificationEmail: http.httpResendVerificationEmail,
  forgotPassword: http.httpForgotPassword,
  resetPassword: http.httpResetPassword,
  logout: http.httpLogout,
  getCurrentUser: http.httpGetCurrentUser,
  updateProfile: http.httpUpdateProfile,
  changePassword: http.httpChangePassword,
};

export const authService: AuthService = env.useMock ? mockAuthService : httpAuthService;
